import { Button, Form, Input, Modal, Select, Switch } from "antd";
import { useState } from "react";

import { selectFormOptionsNoFormatting } from "../../../../../utils/helper";
import { showErrorNotification } from "../../../../../utils/notification";

const CreateEditTaskModal = ({
  isModalOpen = false,
  isEdit = false,
  setIsModalOpen = () => {},
  initialValues = {},
  handleCreateEdit = () => {}
}) => {
  const [form] = Form.useForm();
  const [isScorable, setIsScorable] = useState(false);
  const [isCodeforcesSync, setIsCodeforcesSync] = useState(false);
  const [isBonus, setIsBonus] = useState(false);

  const handleLinkChange = (e) => {
    const link = e.target.value;
    const scorableSubstrings = ["codeforces.com/problemset", "codeforces.com/contest"];
    // Check if the link includes any of the scorable substrings
    const isScorable = scorableSubstrings.some((substring) => link.includes(substring));
    setIsCodeforcesSync(isScorable);
    form.setFieldsValue({ isCodeforcesSync: isScorable });
  };

  const handleCodeforcesSyncToggle = () => {
    showErrorNotification(
      `This Problem is ${!isCodeforcesSync && "not "}Syncable with Codeforces.`
    );
  };

  const handleScoreTypeChange = (value) => {
    if (value === "SCORABLE") {
      setIsScorable(true);
      setIsBonus(false);
      form.setFieldsValue({ scorable: true, bonus: false });
    } else if (value === "NON_SCORABLE") {
      setIsScorable(false);
      setIsBonus(false);
      form.setFieldsValue({ scorable: false, bonus: false });
    } else if (value === "BONUS") {
      setIsScorable(false);
      setIsBonus(true);
      form.setFieldsValue({ scorable: false, bonus: true });
    }
  };

  return (
    <Modal
      title="Create/Edit Task"
      centered
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => setIsModalOpen(false)}
    >
      <Form
        form={form}
        initialValues={isEdit ? initialValues : {}}
        name="new_subsection_form"
        onFinish={handleCreateEdit}
      >
        <Form.Item
          name="title"
          label="Title"
          rules={[
            {
              required: true,
              message: "Please enter a title!"
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="category"
          label="Platform"
          rules={[
            {
              required: true,
              message: "Please select a platform!"
            }
          ]}
        >
          <Select
            options={selectFormOptionsNoFormatting([
              "CODEFORCES_PROBLEM",
              "OTHER_WITH_LINK",
              "OTHER",
              "CODECHEF_PROBLEM",
              "ATCODER_PROBLEM",
              "CSES_PROBLEM",
              "GFG_PROBLEM",
              "LEETCODE_PROBLEM",
              "HACKEREARTH_PROBLEM",
              "HACKERRANK_PROBLEM",
              "SPOJ_PROBLEM"
            ])}
            showSearch
            allowClear
          />
        </Form.Item>
        <Form.Item
          name="dayNumber"
          label="Day in the Week"
          rules={[
            {
              required: true,
              message: "Please select a day!"
            }
          ]}
        >
          <Select
            options={[
              { value: "1", label: "1" },
              { value: "2", label: "2" },
              { value: "3", label: "3" },
              { value: "4", label: "4" },
              { value: "5", label: "5" },
              { value: "6", label: "6" },
              { value: "7", label: "7" },
              { value: "8", label: "Bonus Problem" }
            ]}
            showSearch
            allowClear
          />
        </Form.Item>
        <Form.Item
          name="link"
          label="Link"
          rules={[
            {
              required: true,
              message: "Please enter a valid link!"
            },
            {
              pattern: /^(https:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?$/,
              message: "Please paste a valid link!"
            }
          ]}
        >
          <Input onChange={handleLinkChange} />
        </Form.Item>
        <Form.Item name="videoSolutionUrl" label="Video Solution Link">
          <Input />
        </Form.Item>
        <Form.Item
          name="scoreType"
          label="Score Type"
          rules={[{ required: true, message: "Please Select a Suitable one" }]}
        >
          <Select
            options={selectFormOptionsNoFormatting(["SCORABLE", "NON_SCORABLE", "BONUS"])}
            onChange={handleScoreTypeChange}
          />
        </Form.Item>
        <Form.Item name="scorable" label="Toggle on for Scorable" valuePropName="checked">
          <Switch checked={isScorable} disabled={true} />
        </Form.Item>
        <Form.Item name="bonus" label="Toggle on for Bonus" valuePropName="checked">
          <Switch checked={isBonus} disabled={true} />
        </Form.Item>
        <Form.Item
          name="isCodeforcesSync"
          label="Is problem sync on Codeforces"
          valuePropName="checked"
        >
          <Switch
            checked={isCodeforcesSync}
            disabled={true}
            onChange={handleCodeforcesSyncToggle}
          />
        </Form.Item>

        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            {isEdit === true ? "Update" : "Create"} Task
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateEditTaskModal;
